const MobileContainer = ({ children }) => {
	return <div className="vs--stake-container">{children}</div>;
};

export default MobileContainer;
